import { RolByIdPipe } from './../pipes/rol-by-id.pipe';
import { FallbackImgDirective } from './../directives/fallback-img.directive';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentTypePipe } from '../pipes/document-type.pipe';
import { BgUrlPipe } from '../pipes/bg-url.pipe';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { UiSwitchModule } from 'ngx-ui-switch';
import { AlertColorDirective } from '../directives/alert-color.directive';
import { OutsideDirective } from '../directives/outside.directive';
import { UppercaseDirective } from '../directives/uppercase.directive';
import { OnlyNumberDirective } from '../directives/only-number.directive';
import { OnlyAlphaDirective } from '../directives/only-alpha.directive';
import { ValidateDocumentDirective } from '../directives/validate-document.directive';
import { TextWithSpacesDirective } from '../directives/text-with-spaces.directive';
import { OnlySpecialCharacDirective } from '../directives/only-specialCharac.directive';
import { ReplacePipe } from '../pipes/replace.pipe';
import { FilterPipe } from '../pipes/filter.pipe';
import { NullDateReplacerPipe } from '../pipes/null-date-replacer.pipe';
import { FormatNumberPipe } from '../pipes/format-number.pipe';
import { SumPipe } from '../pipes/sum.pipe';
import { TooltipDirective } from '../directives/tooltip.directive';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { ImageCropperModule } from 'ngx-image-cropper';
import { SelectLabelDirective } from '@app/directives/select-label.directive';
import { ValidateEmailDirective } from '@app/directives/validate-email.directive';
import { InactivityDirective } from '@app/directives/inactivity.directive';

/*DatePicker*/
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
  OwlDateTimeIntl,
  OWL_DATE_TIME_LOCALE,
  DateTimeAdapter,
  OWL_DATE_TIME_FORMATS,
} from 'ng-pick-datetime';
import { MomentDateTimeAdapter } from 'ng-pick-datetime-moment';

export const MY_CUSTOM_FORMATS = {
  parseInput: 'DD/MM/YYYY',
  fullPickerInput: 'DD/MM/YYYY hh:mm a',
  datePickerInput: 'DD/MM/YYYY',
  timePickerInput: 'hh:mm a',
  monthYearLabel: 'MMM-YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM-YYYY',
};

import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEsCO from '@angular/common/locales/es-CO';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PaymentStateDirective } from '../directives/payment-state.directive';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { TableEmptyStateComponent } from './components/table-empty-state/table-empty-state.component';
import { ErrorValidationComponent } from './components/error-validation/error-validation.component';
registerLocaleData(localeEsCO, 'es-Co');

export class DefaultIntl extends OwlDateTimeIntl {
  rangeFromLabel = 'Fecha inicial';
  rangeToLabel = 'Fecha final';
  hour12AMLabel = 'AM';
  hour12PMLabel = 'PM';
  prevMultiYearLabel = '21 años atrás';
  nextMultiYearLabel = 'Próximos 21 años';
}

@NgModule({
  declarations: [
    DocumentTypePipe,
    BgUrlPipe,
    RolByIdPipe,
    AlertColorDirective,
    OutsideDirective,
    UppercaseDirective,
    OnlyNumberDirective,
    OnlyAlphaDirective,
    ValidateDocumentDirective,
    TextWithSpacesDirective,
    OnlySpecialCharacDirective,
    FallbackImgDirective,
    ReplacePipe,
    FilterPipe,
    NullDateReplacerPipe,
    FormatNumberPipe,
    SumPipe,
    TooltipDirective,
    PaymentStateDirective,
    TableEmptyStateComponent,
    ErrorValidationComponent,
    SelectLabelDirective,
    ValidateEmailDirective,
    InactivityDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgxExtendedPdfViewerModule,
    NgxSpinnerModule,
    ImageCropperModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    BrowserAnimationsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    UiSwitchModule.forRoot({
      size: 'small',
      color: '#135AA3',
      switchColor: '#FFFFFF',
      defaultBgColor: '#8D8D8D',
      defaultBoColor: '#dadada',
      checkedLabel: 'Si',
      uncheckedLabel: 'No',
    }),
    NgxDropzoneModule,
  ],
  providers: [
    {
      provide: DateTimeAdapter,
      useClass: MomentDateTimeAdapter,
      deps: [OWL_DATE_TIME_LOCALE],
      useValue: 'es',
    },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_CUSTOM_FORMATS },
    { provide: OwlDateTimeIntl, useClass: DefaultIntl },
    { provide: LOCALE_ID, useValue: 'es-Co' },
  ],
  exports: [
    DocumentTypePipe,
    RolByIdPipe,
    BgUrlPipe,
    FormsModule,
    NgxSpinnerModule,
    ImageCropperModule,
    AlertColorDirective,
    OutsideDirective,
    UppercaseDirective,
    OnlyNumberDirective,
    OnlyAlphaDirective,
    TextWithSpacesDirective,
    OnlySpecialCharacDirective,
    FallbackImgDirective,
    ReplacePipe,
    UiSwitchModule,
    FilterPipe,
    NullDateReplacerPipe,
    FormatNumberPipe,
    SumPipe,
    TooltipDirective,
    PaymentStateDirective,
    NgxDropzoneModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    BrowserAnimationsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgxExtendedPdfViewerModule,
    TableEmptyStateComponent,
    ErrorValidationComponent,
    SelectLabelDirective,
    ValidateEmailDirective,
    InactivityDirective,
    ValidateDocumentDirective
  ],
})
export class SharedModule {}
